import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import ChecklistPickerModal from './ChecklistPickerModal'
import FilterLink from '../../../components/filter/FilterLink'

const ChecklistPicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation(['checklists', 'common'])
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiListCheck2'}
        label={label || t('checklists:checklist')}
        value={compactString(value, { t: t, tField: 'checklistIds' })}
        onClick={() => setOpen(true)}
      />
      <ChecklistPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default ChecklistPicker
